import styled, { css } from 'styled-components';

import { mediaSize, theme, hideOverflowText } from '../../../styles';

export const Logo = styled.img`
  object-fit: contain;
  width: 31px;
  height: 31px;
  
  @media (max-width: ${mediaSize.desktop}) {
    margin-right: 0;
  } 
`;
export const LogoText = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  margin: 0 11px;
  color: ${theme.colors.backgroundLightBlue};
  ${hideOverflowText}
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const LogoWrap = styled(UserInfo)`  
  padding: 20px 20px 5px 20px;
  cursor: ${({ plain }) => plain ? 'default' : 'pointer'};
    svg {
      display: ${({ plain }) => plain ? 'none' : 'initial'};
    }
  ${({ collapsed }) => collapsed && css`justify-content: center`};
`;



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar-header/styled-components.js